
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["iconify iconify--iconoir",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","width":"32","height":"32","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke-width":"1.5","fill":"none","stroke":"currentColor"}},[_c('path',{attrs:{"d":"M20 10c0 4.418-8 12-8 12s-8-7.582-8-12a8 8 0 1116 0z"}}),_c('path',{attrs:{"d":"M12 11a1 1 0 100-2 1 1 0 000 2z","fill":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}})])])
          )
        }
      }
    